import "../stylesheets/App.css";
import "../stylesheets/DashboardAdmin.css";
import React, { useEffect, useState } from "react";
import HeaderHome from "./subcomponents/HeaderHome.js";
import PopupDeactivateUser from "./subcomponents/PopupDeactivateUser.js";
import UserAdminInformation from "./subcomponents/UserAdminInformation.js";
import Loader from "./subcomponents/Loader.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useNavigate, useParams } from "react-router-dom";

function DetailAdmin() {
  const navigate = useNavigate();
  const { idUser } = useParams(); // ✅ viene de /admin/detail/:idCategory/:idUser

  const [loadingUser, setLoadingUser] = useState(true);
  const [loadingIsAdmin, setLoadingIsAdmin] = useState(true);
  const [loadingDeactivateUser, setLoadingDeactivateUser] = useState(false);

  const [user, setUser] = useState({});
  const [deactivateUserId, setDeactivateUserId] = useState(null);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    // ✅ Si no está logueado o no es admin -> redirect (pero dentro de effect)
    const raw = localStorage.getItem("user-info");
    if (!raw) {
      navigate("/");
      return;
    }
    const parsed = JSON.parse(raw);
    if (!parsed.is_admin) {
      navigate("/");
      return;
    }

    // (Opcional) UI tweaks
    const htmlRef = document.getElementById("html-ref");
    if (htmlRef) htmlRef.style.overflowY = "auto";

    const search = document.getElementById("search-container-home");
    if (search) search.style.visibility = "hidden";

    const controller = new AbortController();

    const run = async () => {
      try {
        // ✅ 1) verifico admin en back
        const adminRes = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/admin/is-admin/${parsed.idUser}`,
          { signal: controller.signal }
        ).then((r) => r.json());

        setLoadingIsAdmin(false);

        if (!adminRes?.data) {
          navigate("/");
          return;
        }

        // ✅ 2) traigo usuario
        const userRes = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/users/detail/${idUser}`,
          { signal: controller.signal }
        ).then((r) => r.json());

        setUser(userRes?.data || {});
      } catch (e) {
        // si abort -> ignore
        console.log(e);
      } finally {
        setLoadingUser(false);
      }
    };

    run();

    return () => controller.abort();
  }, [navigate, idUser]);

  useEffect(() => {
    if (refresh) navigate("/admin");
  }, [refresh, navigate]);

  const deactivate = () => {
    if (user?.idUser) setDeactivateUserId(user.idUser);
  };

  return (
    <>
      <HeaderHome />
      <section id="module-users-section-detail" className="detail-admin-page">
        <button className="header-btn" onClick={() => window.history.back()}>
          <FontAwesomeIcon icon={solid("chevron-left")} />
        </button>

        <UserAdminInformation user={user} />

        <button className="btn dark-turq-btn" onClick={deactivate}>
          Eliminar usuario
        </button>
      </section>

      {(loadingIsAdmin || loadingUser || loadingDeactivateUser) ? <Loader /> : null}

      {deactivateUserId ? (
        <PopupDeactivateUser
          id={deactivateUserId}
          setDeactivateUser={setDeactivateUserId}
          setRefresh={setRefresh}
          setLoadingDeactivateUser={setLoadingDeactivateUser}
        />
      ) : null}
    </>
  );
}

export default DetailAdmin;
